import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaBirthdayCake, FaHeart, FaStar } from 'react-icons/fa';

const Loader = () => {
  const [dots, setDots] = useState([]);

  useEffect(() => {
    const points = Array.from({ length: 16 }).map(() => ({
      x: Math.random() * 100,
      y: Math.random() * 100,
      delay: Math.random() * 2,
    }));
    setDots(points);
  }, []);

  return (
    <div className="birthday-loader">
      <div className="birthday-loader-bg">
        {dots.map((dot, index) => (
          <motion.div
            key={index}
            className="birthday-loader-dot"
            style={{ left: `${dot.x}%`, top: `${dot.y}%` }}
            animate={{ y: [0, -12, 0], opacity: [0.4, 1, 0.4] }}
            transition={{ duration: 2.2, repeat: Infinity, delay: dot.delay }}
          />
        ))}
      </div>

      <motion.div
        className="birthday-loader-card"
        initial={{ scale: 0.92, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="birthday-loader-icons">
          <FaHeart />
          <FaStar />
          <FaBirthdayCake />
        </div>
        <p>Preparing your birthday surprise...</p>
      </motion.div>
    </div>
  );
};

export default Loader;
